<template>
  <div class="sf-empty-state">
    <img
      class="sf-empty-state-image"
      :alt="I18n.t('company_links.empty_state.title')"
      :src="$imagesRequire('empty_states/adjustments.svg')"
    />
    <div class="sf-empty-state-title">
      {{ I18n.t('company_links.empty_state.title') }}
    </div>
    <div class="sf-c-text sf-below-1">
      <span
        v-dompurify-html="I18n.t('company_links.empty_state.message_html')"
      />
    </div>
    <div class="tw-flex tw-justify-center">
      <SfButton
        v-if="showManageCompanyLinks"
        class="sf-btn sf-btn-primary sf-c-white"
        @click="openManageCompanyLinksModal"
      >
        <i class="icon-plus sf-pad-r-1" />
        {{ I18n.t('company_links.empty_state.create') }}
      </SfButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import useI18n from '@app/shared/vue/composables/use-I18n'
import SfButton from '@app/shared/vue/components/sf-button/sf-button.vue'
import { isFeatureSupported } from '@app/adapters/silverfin'

const I18n = useI18n()

const showManageCompanyLinks = isFeatureSupported('supports_company_links')

const openManageCompanyLinksModal = () => {
  window.modalCitizen.openModalPortal('manage-company-links-modal')
}
</script>
